import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import ResellersSection from '../components/ResellersSection';
import BackToOverview from '../components/BackToOverview';

const PartnersPage: React.FC = () => {
  useRouteMeta('partners');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.partners.eyebrow}
        title={r.routes.partners.heroTitle}
        subtitle={r.routes.partners.heroSubtitle}
      />
      <ResellersSection />
      <BackToOverview />
    </>
  );
};

export default PartnersPage;
